<template>
	<div>
		<div class="top" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
			{{details.title}}
		</div>
		<div class="main" v-html="details.txt"></div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				details: {

				}
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = ''
			that.getInfo()
		},
		methods: {
			getInfo() {
				let that = this
				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: {
						channelId: that.$store.state.channelId,
						releaseTerrace: "releasePc"
					}
				}).then(res => {
					if(res.code === 'S200') {
						res.data.some(item => {
							if(item.channelId == that.$store.state.channelId) {
								that.details = item
								if(that.details.txt) {
									that.format()
								}
								return true
							}
						})
					}
				})
			},
			format() {
				var html = this.details.txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				this.details.txt = newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.top {
		height: 46px;
		line-height: 46px;
		font-size: 18px;
		text-align: center;
		color: #264EA7;
		width: 1000px;
		margin: 40px auto 10px;
		border-bottom: 3px solid #EDD68E;
	}
	.main {
		width: 1140px;
		margin: 30px auto 80px;
		padding: 0 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/into_museum/dsjj.vue